import { Box } from '@change-corgi/design-system-legacy/layout';

import { DecisionMakersMainWrapper } from '../decisionMakers/DecisionMakersMainWrapper';
import { LegislativeBodiesContainer } from '../decisionMakersLegislativeBodies/LegislativeBodiesContainer';

import { useDecisionMakerSection } from './hooks/useDecisionMakerSection';

export const DecisionMakerSection: React.FC = () => {
	const {
		data: { showLegislativeBodies },
	} = useDecisionMakerSection();

	return showLegislativeBodies ? (
		<Box mx={[-16, 0]}>
			<LegislativeBodiesContainer />
		</Box>
	) : (
		<DecisionMakersMainWrapper />
	);
};
